<template>
	<div class="loading-regular">
		<div class="loading-regular-bounce loading-regular-bounce1" />
		<div class="loading-regular-bounce loading-regular-bounce2" />
		<div class="loading-regular-bounce loading-regular-bounce3" />
	</div>
</template>

<script>
export default {
	name: 'LoadingRegular'
}
</script>

<style lang="scss">
	.loading-regular {
		width: 70px;
		text-align: center;
	}

	.loading-regular > .loading-regular-bounce {
		width: 18px;
		height: 18px;
		background-color: #333;

		border-radius: 100%;
		display: inline-block;
		-webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
		animation: sk-bouncedelay 1.4s infinite ease-in-out both;
	}

	.loading-regular .loading-regular-bounce1 {
		-webkit-animation-delay: -0.32s;
		animation-delay: -0.32s;
	}

	.loading-regular .loading-regular-bounce2 {
		-webkit-animation-delay: -0.16s;
		animation-delay: -0.16s;
	}

	@-webkit-keyframes sk-bouncedelay {
		0%, 80%, 100% { -webkit-transform: scale(0) }
		40% { -webkit-transform: scale(1.0) }
	}

	@keyframes sk-bouncedelay {
		0%, 80%, 100% { -webkit-transform: scale(0); transform: scale(0); }
		40% { -webkit-transform: scale(1.0); transform: scale(1.0); }
	}
</style>
